// Published product pages from AppRouter; exclude retired routes that show Home.
export const referralProducts = [
  { id: "rev-f-amplifier-suite", name: "Rev F Amplifier Suite" },
  { id: "distant-amplifier-suite", name: "Distant Amplifier Suite" },
  { id: "distant-bass-suite", name: "Distant Bass Suite" },
  { id: "distant-tone-bundle", name: "Distant Tone Bundle" },
  { id: "dd-amplifier-suite", name: "ToneSuite - Dave Davidson" },
  { id: "nam-universal-ii", name: "NAM Universal II" },
  { id: "protone-deadhorse", name: "Pro Tone Dead Horse" },
  { id: "protone-midboost", name: "Pro Tone Cor Mid Boost" },
  { id: "protone-monsterfuzz", name: "Pro Tone Monster Fuzz" },
  { id: "protone-pedals-bundle", name: "Pro Tone Pedals Bundle" },
];

export function productReferralLink(personalLink: string, productId: string): string {
  if (!referralProducts.some(product => product.id === productId)) return personalLink;
  const url = new URL(personalLink);
  url.pathname = `/product/${productId}`;
  return url.toString();
}
